import { stringify } from 'query-string';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { stringifyOptions } from '@atlassian/jira-servicedesk-reports-common/src/common/constants';
import { isCustomTimeScale } from '@atlassian/jira-servicedesk-reports-common/src/common/summary/main';
import { transformSource } from '@atlassian/jira-servicedesk-reports-common/src/common/utils/drill-down/index.tsx';
import type {
	DrillDownRequest,
	TransformedDrillDownResponse,
} from '@atlassian/jira-servicedesk-reports-common/src/common/utils/drill-down/types.tsx';

export const getDrillDownUrl = ({
	baseUrl,
	projectKey,
	seriesId,
	timescaleId,
	date,
	timeBreakdown,
	start,
	limit,
}: DrillDownRequest) =>
	`${baseUrl}/rest/servicedesk/reports/1/servicedesk/${projectKey}/series/${seriesId}/drilldown/predefined?${stringify(
		{
			date,
			timeBreakdown,
			timescaleId,
			start,
			limit,
			_: Date.now(),
		},
		// @ts-expect-error - TS2559 - Type '{ readonly skipNull: true; readonly sort: false; }' has no properties in common with type 'StringifyOptions'.
		stringifyOptions,
	)}`;

export const getDrillDownUrlByDateRange = ({
	baseUrl,
	projectKey,
	seriesId,
	date,
	timeBreakdown,
	timescaleId,
	start,
	limit,
}: DrillDownRequest) =>
	`${baseUrl}/rest/servicedesk/reports/1/servicedesk/${projectKey}/series/${seriesId}/drilldown/predefined/date-range?${stringify(
		{
			date,
			timeBreakdown,
			timescaleId,
			start,
			limit,
			_: Date.now(),
		},
		// @ts-expect-error - TS2559 - Type '{ readonly skipNull: true; readonly sort: false; }' has no properties in common with type 'StringifyOptions'.
		stringifyOptions,
	)}`;

export const get = async (request: DrillDownRequest): Promise<TransformedDrillDownResponse> => {
	const url = isCustomTimeScale(request.timescaleId)
		? getDrillDownUrlByDateRange(request)
		: getDrillDownUrl(request);

	const response = await fetchJson(url, {
		method: 'GET',
		signal: request.signal,
	});

	return transformSource(request, response);
};
